import React from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'

import Container from 'components/Container'
import AccountButton from './components/AccountButton'
import GetTokenButton from './components/GetTokenButton'

import logo from 'assets/img/dice.png'

const TopBar = () => {
  const history = useHistory()
  const handleGoHome = () => {
    history.push('/')
  }

  return (
    <StyledTopBar>
      <Container size="lg">
        <StyledTopBarInner>
          <StyledAccountButtonWrapper onClick={handleGoHome}>
            <Logo src={logo} />
            <StyledLogoTitle>You Bet!</StyledLogoTitle>
          </StyledAccountButtonWrapper>
          <StyledAccountButtonWrapper>
          < GetTokenButton />
            <AccountButton />
          </StyledAccountButtonWrapper>
        </StyledTopBarInner>
      </Container>
    </StyledTopBar>
  )
}

const StyledTopBar = styled.div``

const Logo = styled.img`
  width: 55px;
`

const StyledLogoTitle = styled.div`
  font-size: 28px;
  font-weight: bold;
  margin-left: 10px;
  color: ${(props) => props.theme.color.grey[600]};
  font-family: 'Kaushan Script', sans-serif;
`

const StyledTopBarInner = styled.div`
  align-items: center;
  display: flex;
  height: ${(props) => props.theme.topBarSize}px;
  justify-content: space-between;
  max-width: ${(props) => props.theme.siteWidth}px;
  width: 100%;
`

const StyledAccountButtonWrapper = styled.div`
  background-color: transparent;
  border: none;
  outline: none !important;
  text-decoration: none;
  align-items: center;
  display: flex;
  cursor: pointer;
  justify-content: flex-end;
  @media (max-width: 400px) {
    justify-content: center;
    width: auto;
  }
`

export default TopBar
